module.exports = __webpack_public_path__ + "static/img/bg46.f5616451.png";